<template>
  <div>
    página pix
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>